import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './locales/de';

import en from './locales/en';
import fr from './locales/fr';
import it from './locales/it';

const SUPPORTED_LANGUAGES = ['de', 'en', 'fr', 'it'];
// Zuletzt gewählte Sprache, damit die Anmeldeseite nach dem Neuladen in dieser Sprache startet
const LANGUAGE_STORAGE_KEY = 'uiLanguage';

/**
 * Startsprache vor der Anmeldung: zuerst ?lang= aus Links (Einladung, Passwort zurücksetzen),
 * dann die zuletzt gewählte Sprache, sonst Deutsch. Nach der Anmeldung gilt die Profilsprache (App.tsx).
 */
const initialLanguage = (): string => {
    if (typeof window === 'undefined') return 'de';
    try {
        const fromLink = new URLSearchParams(window.location.search).get('lang');
        if (fromLink && SUPPORTED_LANGUAGES.includes(fromLink)) return fromLink;
    } catch { /* ohne gültige URL bleibt es beim nächsten Schritt */ }
    try {
        const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
        if (stored && SUPPORTED_LANGUAGES.includes(stored)) return stored;
    } catch { /* Speicher gesperrt (z.B. privates Fenster) */ }
    return 'de';
};

const startLanguage = initialLanguage();

i18n
  .use(initReactI18next)
  .init({
    lng: startLanguage,
    fallbackLng: 'de',
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: {
      escapeValue: false, // React schützt bereits vor XSS
    },
    resources: {
      de: {
        translation: de,
      },
      en: {
        translation: en,
      },
      fr: {
        translation: fr,
      },
      it: {
        translation: it,
      },
    },
  });

// Jede Sprachwahl merken (Anmeldeseite, Einladungslink, Profilsprache nach der Anmeldung)
i18n.on('languageChanged', (lng) => {
    if (!SUPPORTED_LANGUAGES.includes(lng)) return;
    // Auch Seiten ohne Sprachwahl (z.B. ungültiger Einladungslink) nennen Screenreadern die richtige Sprache
    if (typeof document !== 'undefined') document.documentElement.lang = lng;
    try {
        window.localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
    } catch { /* Speicher gesperrt: die Sprache gilt dann nur bis zum Neuladen */ }
});
if (typeof document !== 'undefined') document.documentElement.lang = startLanguage;

export default i18n;
